<wl-content-section [id]="id()" [theme]="theme()">
  @if (headingField() && videoIdField()) {
    <wl-video
      [headingField]="headingField()!"
      [videoIdField]="videoIdField()!"
      [descriptionField]="descriptionField()"
    />
  }
</wl-content-section>
